import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=db5e90ec&scoped=true&"
import script from "./ProcessItem.vue?vue&type=script&lang=js&"
export * from "./ProcessItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=db5e90ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5e90ec",
  null
  
)

export default component.exports